import {ar} from './ar'
import {en} from './en'

export const t = {
  ar,
  en,
}
